"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tournament_api_1 = require("@l2p/tournament-api");
var prepareBonusType = function (currency, bonus) {
    var _a, _b;
    var reward = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _a === void 0 ? void 0 : _a[0];
    var amountItem = (_b = reward === null || reward === void 0 ? void 0 : reward.addedToBalance) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.currency === currency; });
    return {
        percents: reward === null || reward === void 0 ? void 0 : reward.relativePercent,
        freespins: reward === null || reward === void 0 ? void 0 : reward.freeRoundsCount,
        amount: amountItem
            ? "".concat(amountItem.amount, " ").concat(amountItem.currency)
            : undefined,
    };
};
var prepareRewards = function (_a) {
    var rewards = _a.rewards, currency = _a.currency, bonuses = _a.bonuses;
    if (rewards) {
        return rewards.map(function (item, idx) {
            var _a, _b;
            var bonus = item.type === tournament_api_1.TournamentRewardType.Bonus
                ? bonuses === null || bonuses === void 0 ? void 0 : bonuses.find(function (b) { return b.id === item.bonusId; })
                : null;
            return {
                amount: (item === null || item === void 0 ? void 0 : item.type) === tournament_api_1.TournamentRewardType.Balance
                    ? ((_b = (_a = item === null || item === void 0 ? void 0 : item.amount) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.currency === currency; })) === null || _b === void 0 ? void 0 : _b.amount) ||
                        0
                    : 0,
                freeSpins: (item === null || item === void 0 ? void 0 : item.type) === tournament_api_1.TournamentRewardType.FreeRounds
                    ? String(item === null || item === void 0 ? void 0 : item.value)
                    : '',
                loyaltyExp: (item === null || item === void 0 ? void 0 : item.type) === tournament_api_1.TournamentRewardType.LoyalityExp
                    ? "".concat(item.value)
                    : '',
                loyaltyPoints: item.type === tournament_api_1.TournamentRewardType.LoyalityPoints
                    ? String(item.value)
                    : '',
                physicalReward: item.type === tournament_api_1.TournamentRewardType.Physical
                    ? String(item.physicalReward)
                    : '',
                bonus: (item === null || item === void 0 ? void 0 : item.type) === tournament_api_1.TournamentRewardType.Bonus
                    ? prepareBonusType(currency, bonus)
                    : null,
                place: idx + 1,
            };
        });
    }
    return [];
};
exports.default = prepareRewards;
